/**
 * Faixas de faturamento anual (PJ) para cadastro público.
 * `valueCentavos` = teto da faixa em centavos (R$ × 100), enviado ao backend / Pagar.me como `annual_revenue`.
 */
export const ANNUAL_REVENUE_BANDS = [
  { label: 'Até R$ 5.000 por ano', valueCentavos: '500000' },
  { label: 'De R$ 5.001 a R$ 10.000 por ano', valueCentavos: '1000000' },
  { label: 'De R$ 10.001 a R$ 50.000 por ano', valueCentavos: '5000000' },
  { label: 'De R$ 50.001 a R$ 100.000 por ano', valueCentavos: '10000000' },
  { label: 'De R$ 100.001 a R$ 500.000 por ano', valueCentavos: '50000000' },
  { label: 'De R$ 500.001 a R$ 1 milhão por ano', valueCentavos: '100000000' },
  { label: 'Acima de R$ 1 milhão por ano', valueCentavos: '250000000' },
] as const;

export function isKnownAnnualRevenueBand(value: string): boolean {
  const v = value.replace(/\D/g, '');
  return ANNUAL_REVENUE_BANDS.some((b) => b.valueCentavos === v);
}

export function annualRevenueBandLabel(value: string): string {
  const v = value.replace(/\D/g, '');
  const b = ANNUAL_REVENUE_BANDS.find((x) => x.valueCentavos === v);
  return b?.label ?? (v ? `R$ ${v} (valor informado)` : '—');
}
